import { apiClient } from './apiClient';

export enum ReportStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}

export interface ReportDTO {
  id: string;
  reporterId: string;
  reportedId: string;
  title: string;
  description: string;
  reason: string;
  status: ReportStatus;
  adminFeedback?: string;
  createdAt: string;
  updatedAt: string;
  reporter?: {
    name: string;
  };
  reported?: {
    name: string;
  };
}

export interface CreateReportDTO {
  reportedId: string;
  title: string;
  description: string;
  reason: string;
}

export interface ProcessReportDTO {
  status: ReportStatus.APPROVED | ReportStatus.DENIED;
  adminFeedback?: string;
}

export const listReports = () => apiClient.get<ReportDTO[]>('/reports');

export const getReport = (id: string) => apiClient.get<ReportDTO>(`/reports/${id}`);

export const createReport = (data: CreateReportDTO) => apiClient.post<ReportDTO>('/reports', data);

export const processReport = (id: string, data: ProcessReportDTO) => 
  apiClient.patch<ReportDTO>(`/reports/${id}/process`, data);
